"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootBlockSagas = void 0;
var effects_1 = require("redux-saga/effects");
var PlaceSaga_1 = require("@/pages/place/sagas/PlaceSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var PlaceFollowedApiSaga_1 = require("@/pages/place/sagas/api/PlaceFollowedApiSaga");
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var BuildingVisitTracker_1 = require("@/pages/place/sagas/api/BuildingVisitTracker");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var SignupAction_1 = require("@/pages/common/actions/SignupAction");
var BlockTopGallerySaga_1 = require("@/pages/place/sagas/BlockTopGallerySaga");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var getPlaceName = function (state) { return state.place.nameMain; };
var getBlockId = function (state) { return state.place.id; };
var getIsFollowing = function (state) { return state.place.saveSearchId > -1; };
var getStateCallback = function () {
    var state, customName;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select()];
            case 1:
                state = _a.sent();
                customName = state.place.nameMain;
                state.hfilter.listingType = SfilterTypeGroup_1.SfilterType.toListingPurposeType(state.place.type);
                state.hfilter.keyword = customName;
                return [2 /*return*/, state];
        }
    });
};
var getNameCallback = function () {
    var state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select()];
            case 1:
                state = _a.sent();
                return [2 /*return*/, state.place.nameMain];
        }
    });
};
var getListingPurposeType = function (state) { return state.place.type; };
var checkBlockFollowState = function () {
    var placeName, lang, sfilterType, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getPlaceName)];
            case 1:
                placeName = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(getListingPurposeType)];
            case 3:
                sfilterType = _a.sent();
                return [4 /*yield*/, effects_1.call(PlaceFollowedApiSaga_1.checkPlaceFollowedApi, placeName, sfilterType, lang)];
            case 4:
                response = _a.sent();
                if (response && response.data && response.data.userSearchSetId) {
                    return [2 /*return*/, response.data.userSearchSetId];
                }
                return [2 /*return*/];
        }
    });
};
var transformSearchQuery = function (searchQuery) {
    return __generator(this, function (_a) {
        searchQuery.searchSaveSetType = SaveSearchSet_1.SearchSaveSetType.Building;
        return [2 /*return*/, searchQuery];
    });
};
var trackVisit = function () {
    var id, forkTask;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getBlockId)];
            case 1:
                id = _a.sent();
                return [4 /*yield*/, effects_1.call(BuildingVisitTracker_1.BuildingVisitTracker.log, id)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.race({
                        galleryClicked: effects_1.take(PlaceAction_1.default.PLACE_SET_GALLERY_INDEX),
                        enquireClicked: effects_1.take(function (action) { return action.type === EnquireAction_1.default.SET_ENQUIRE_ACTIVE && action.payload === false; }),
                        popupClosedClicked: effects_1.take(function (action) { return action.type === PlaceAction_1.default.PLACE_SHOW_POP && action.payload === 3; }),
                        hasScrolled: effects_1.take(function (action) { return action.type === PlaceAction_1.default.SET_STICKY && action.payload === true; }),
                        signupClicked: effects_1.take(function (action) { return action.type === SignupAction_1.default.SET_SINGUP_PANEL_ACTIVE && action.payload === false; }),
                    })];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.debounce(2000, GlobalAction_1.default.ON_WINDOW_SCROLL, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, effects_1.call(decideShowPopup)];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, effects_1.cancel(forkTask)];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    })];
            case 4:
                forkTask = _a.sent();
                return [2 /*return*/];
        }
    });
};
var decideShowPopup = function () {
    var id, isFollowing, visitCount;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getBlockId)];
            case 1:
                id = _a.sent();
                return [4 /*yield*/, effects_1.select(getIsFollowing)];
            case 2:
                isFollowing = _a.sent();
                if (isFollowing)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(BuildingVisitTracker_1.BuildingVisitTracker.getRecentVisitCount, id)];
            case 3:
                visitCount = _a.sent();
                if (!(visitCount > 2)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setFollowPopupActive(false))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setFollowPopupActive(true))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
};
var watchOnsaveClickBlockSaga = PlaceSaga_1.watchOnSaveClickSaga(getStateCallback, getNameCallback, transformSearchQuery);
var watchSetUserAndSetFollowBlockState = PlaceSaga_1.watchSetUserAndSetFollowState(checkBlockFollowState);
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(trackVisit)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var displayViewMore = function () {
    var height, state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                height = 0;
                document.querySelectorAll('.c-place__description > p').forEach(function (p) { return height += p.clientHeight; });
                return [4 /*yield*/, effects_1.select()];
            case 2:
                state = _a.sent();
                if (height > 285) {
                    state.place.aboutMore = true;
                    state.place.aboutMoreTextDisplay = false;
                }
                else {
                    state.place.aboutMore = false;
                    state.place.aboutMoreTextDisplay = true;
                }
                return [2 /*return*/];
        }
    });
};
var rootBlockSagas = {
    rootPlaceSagas: PlaceSaga_1.rootPlaceSagas,
    blockTopGallerySagas: BlockTopGallerySaga_1.blockTopGallerySagas,
    watchOnsaveClickBlockSaga: watchOnsaveClickBlockSaga,
    watchSetUserAndSetFollowBlockState: watchSetUserAndSetFollowBlockState,
    watchInit: watchInit,
    displayViewMore: displayViewMore
};
exports.rootBlockSagas = rootBlockSagas;
